import type { ListTableSummaryProps } from "./list-table-summary.type";

import { Table, Typography } from "antd";

import { useListContext } from "@/modules/list";

const ListTableSummary = ({
  label,
  value,
  fixed,
  valueAlign,
  hasBatchControls,
  ...props
}: ListTableSummaryProps) => {
  const { columnsCount } = useListContext();

  const batchColSpan = hasBatchControls ? 1 : 0;
  const labelColSpan = 1; // "name" column
  const gutterColSpan =
    props.gutterColSpan ?? columnsCount - labelColSpan - batchColSpan;

  const batchIndex = 0;
  const labelIndex = hasBatchControls ? 1 : 0;
  const gutterIndex = labelColSpan + batchColSpan;
  const valueIndex = labelColSpan + batchColSpan + gutterColSpan;

  return (
    <Table.Summary fixed={fixed}>
      <Table.Summary.Row>
        {hasBatchControls && (
          <Table.Summary.Cell index={batchIndex} colSpan={batchColSpan} />
        )}
        <Table.Summary.Cell index={labelIndex} colSpan={labelColSpan}>
          <Typography.Text strong>{label ?? "label"}</Typography.Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={gutterIndex} colSpan={gutterColSpan} />
        <Table.Summary.Cell index={valueIndex} align={valueAlign}>
          <Typography.Text strong>{value ?? "value"}</Typography.Text>
        </Table.Summary.Cell>
      </Table.Summary.Row>
    </Table.Summary>
  );
};

export default ListTableSummary;
